﻿export interface IDrugUseHistory {
    recreationalDrug: string,
    yearsAgo: string,
    remissionStatus: string,
    hasAbusedDrug: string,
    hasReceivedTreatment: string
}
